// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .banner {
  background-color: #f6f3f3;
}
.theme-light .banner .images {
  width: 100%;
  height: 300px;
  position: relative;
}
.theme-light .banner .images .cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.theme-light .banner .images h1 {
  font-size: -webkit-xxx-large;
  position: absolute;
  top: 10%;
  left: 10%;
  text-align: center;
  color: white;
}
.theme-dark .banner {
  background-color: #333;
}
.theme-dark .banner .images {
  width: 100%;
  height: 300px;
  position: relative;
}
.theme-dark .banner .images .cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.theme-dark .banner .images h1 {
  font-size: -webkit-xxx-large;
  position: absolute;
  top: 10%;
  left: 10%;
  text-align: center;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/components/banner/banner.scss"],"names":[],"mappings":"AAqBI;EChBE,yBAAA;AAHN;AAMM;EACE,WAAA;EACA,aAAA;EACA,kBAAA;AAJR;AAMQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAJV;AAOQ;EACE,4BAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;AALV;ADCI;EChBE,sBAAA;AAkBN;AAfM;EACE,WAAA;EACA,aAAA;EACA,kBAAA;AAiBR;AAfQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAiBV;AAdQ;EACE,4BAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;AAgBV","sourcesContent":["$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n","\n@import \"../../style.scss\";\n\n.banner {\n    @include themify($themes) {\n      background-color: themed(\"bgSoft\");\n     \n\n      .images {\n        width: 100%;\n        height: 300px;\n        position: relative;\n  \n        .cover {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n        }\n  \n        h1{\n          font-size: -webkit-xxx-large;\n          position: absolute;\n          top: 10%;\n          left: 10%;\n          text-align: center;\n          color: white;\n        }\n      }\n    }\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
